import React from "react";
import { Link } from "react-router-dom";
import "./ErrorPage.css";
import { Box } from "@mui/material";
import img404 from "../asset/space.png";

const ErrorPages = () => {
  return (
    <>
      <Box>
        <div className="headtext2">
          <div className="headimg2">
            <img src={img404} alt="Error Page"/>
          </div>

          <div className="textonimg2">
            <h2 id="shadow">
              {" "}
              Oops...!! &nbsp;
              <span> You are Logged out.&nbsp;</span>
              <span>
                Please click <Link to="/">here</Link> to Login .
              </span>
            </h2>
          </div>
        </div>
      </Box>
    </>
  );
};

export default ErrorPages;
